import { render, staticRenderFns } from "./LocationPage.vue?vue&type=template&id=aaa2d682&scoped=true&"
import script from "./LocationPage.vue?vue&type=script&lang=js&"
export * from "./LocationPage.vue?vue&type=script&lang=js&"
import style0 from "./LocationPage.vue?vue&type=style&index=0&id=aaa2d682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa2d682",
  null
  
)

export default component.exports